import Axios from '@/assets/js/AxiosPlugin'

// 验证记录
export const searchCouponList = params => { return Axios.post('/api/Admin/Record/searchCouponList', params) }

// 验证统计
export const couponStatistics = params => { return Axios.post('/api/Admin/Statistics/coupon', params) }

// 会员使用优惠劵记录
export const searchMemberCouponList = params => { return Axios.post('/api/Admin/Member/searchCouponList', params) }



// WEBPACK FOOTER //
// ./src/views/webpc/CashierDesk/CertificationRecordApp/apis/index.js